/**
 * A ticket's short reference, as a resident reads it (spec 2026-09-13-01).
 *
 * `issues.number` is an integer, sequential per organization. The prefix is the
 * only thing that varies by language — `#1042` in English, `n° 1042` in French —
 * and it is the SAME format the backend composes the acknowledgement sentence
 * with, so a resident quoting what they received lands on the ticket the
 * console shows. No organization prefix: the organization is already the
 * context everywhere a number is displayed.
 */
export function formatIssueReference(number: number | undefined | null, language: string): string {
    if (typeof number !== 'number' || !Number.isFinite(number) || number <= 0) return ''

    return language.toLowerCase().startsWith('fr') ? `n° ${number}` : `#${number}`
}
